import { useState } from 'react';
import { Button, Group, Modal, Stack, Textarea } from '@mantine/core';
import { useTranslation } from 'react-i18next';

const TRANS_KEY = 'BANK_ACCOUNTS.DELETE';

type DeleteBankAccountModalPropsType = {
  opened: boolean;
  onClose: () => void;

  isPending: boolean;
  onSubmitDelete: (reason: string) => Promise<void>;
};

export const DeleteBankAccountModal: React.FC<
  DeleteBankAccountModalPropsType
> = ({ opened, onClose, isPending, onSubmitDelete }) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');

  const handleClose = (): void => {
    setReason('');
    onClose();
  };

  const handleSubmit = async (): Promise<void> => {
    await onSubmitDelete(reason);
    setReason('');
  };

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title={t(`${TRANS_KEY}.MODAL_TITLE`)}
      size="md"
      closeOnClickOutside={false}
    >
      <Stack>
        <Textarea
          label={t(`${TRANS_KEY}.REASON_LABEL`)}
          minRows={3}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
        <Group justify="end">
          <Button
            variant="outline"
            onClick={handleClose}
            color="blue"
            disabled={isPending}
          >
            {t('CANCEL_BUTTON')}
          </Button>
          <Button
            onClick={() => void handleSubmit()}
            color="red"
            loading={isPending}
            disabled={isPending}
          >
            {t(`${TRANS_KEY}.CONFIRM_BUTTON`)}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};
